import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import { vuetify } from './plugins/vuetify'
// import 'vuetify/styles';
import i18n from '../i18n/i18n'
import '@/assets/custom-mdi.css'

import './leaflet/leaflet.css';
import './leaflet/leaflet.js'; // Ruta a tu archivo local
import VueDatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css';
import Highcharts from "highcharts";
import Highcharts3D from 'highcharts/highcharts-3d';
import HighchartsMore from 'highcharts/highcharts-more'
import accessibility from 'highcharts/modules/accessibility';
import Stock from "highcharts/modules/stock";
import exportingInit from "highcharts/modules/exporting";
import exportingData from "highcharts/modules/export-data";
import drilldown from 'highcharts/modules/drilldown';
import mapInit from 'highcharts/modules/map';
import networkgraph from 'highcharts/modules/networkgraph';
import Vue3EasyDataTable from 'vue3-easy-data-table';
import 'vue3-easy-data-table/dist/style.css';



Stock(Highcharts);
exportingInit(Highcharts);
exportingData(Highcharts);
accessibility(Highcharts);
Highcharts3D(Highcharts);
HighchartsMore(Highcharts);
drilldown(Highcharts);
mapInit(Highcharts);
networkgraph(Highcharts);

createApp(App)
  .use(router)
  .use(store)
  .use(i18n)
  .use(vuetify)
  .component('VueDatePicker', VueDatePicker)
  .component('EasyDataTable', Vue3EasyDataTable)
  .mount('#app')
